import { getLanguageOnlyFromLocale } from "@msys/tolgee";
import { useTolgee } from "@tolgee/react";
import React from "react";
import { useUserData } from "../auth/useUserData.js";

type EmptyScreenLocale = "en" | "de";

const localeToEmptyScreenLocale: Record<string, EmptyScreenLocale> = {
  en: "en",
  de: "de",
  fr: "en",
  ru: "en",
  pl: "en",
  nl: "en",
};

interface Props {
  slug: string;
}

const EmptyScreen = ({ slug }: Props) => {
  const viewer = useUserData().currentUser!;
  const locale = useTolgee(["language"]).getLanguage()!;
  const [content, setContent] = React.useState("");

  const language = getLanguageOnlyFromLocale(locale);
  const emptyScreenLanguage = localeToEmptyScreenLocale[language];

  const viewerType = viewer.organisation.isCraftsmanOrganisation
    ? "contractor"
    : "homeowner";

  React.useEffect(() => {
    async function loadScreen() {
      const response = await fetch(
        `/empty-screens/${slug}/${viewerType}/${emptyScreenLanguage}.json`
      );
      let json: any = await response.json();
      setContent(json.content.rendered);
    }
    loadScreen();
  }, [emptyScreenLanguage, slug, viewerType]);

  // Empty-screen copy is static marketing/help content fetched from
  // `/empty-screens/*.json`, so it is safe to record in Session Replay and
  // makes an otherwise blank screen identifiable.
  return (
    <div
      className="sentry-unmask"
      dangerouslySetInnerHTML={{ __html: content }}
    ></div>
  );
};

export default EmptyScreen;
